export function BooleanTransformer(value: boolean | string): boolean {
  return typeof value === 'string' ? value === '' : value;
}
